export function fullName(fistName: string, lastName: string) {
  return `${fistName.trim()} ${lastName.trim()}`.trim();
}
